const topics = [
  { label: '#暑期档', hot: true },
  { label: '#国产剧', hot: true },
  { label: '#悬疑', hot: false },
  { label: '#古装', hot: true },
  { label: '#科幻', hot: false },
  { label: '#综艺', hot: false },
  { label: '#院线新片', hot: true },
  { label: '#动画', hot: false },
  { label: '#纪录片', hot: false },
  { label: '#韩剧', hot: false },
  { label: '#美剧', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            看看大家都在追什么，找到属于你的下一部好剧
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-200 text-foreground-600 hover:bg-background-300'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-foreground-500 mt-6">
          共 11 个话题标签 · 点击发现更多精彩内容
        </p>
      </div>
    </section>
  );
}